import { Async } from '../../../weborder/Data';
import { OrderHistoryData, SetOrderHistory } from './order.types';

export const setOrderHistory = (
  orderHistory: Async<OrderHistoryData[]>,
): SetOrderHistory => ({
  type: 'SET_ORDER_HISTORY',
  payload: orderHistory,
});
